const GoogleAds = ({ useIntersect = false } = {}) => {
    return {
        init(){
            const adsSource = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

            const scripts = Array.from(document.scripts ?? []);
            const adsJs = scripts.find((script) => script?.src === adsSource);

            if (adsJs instanceof HTMLScriptElement){
                this.handleAdMount();
                return;
            }

            const script = document.createElement('script');

            script.src = adsSource;
            script.async = true;
            script.onload = () => this.handleAdMount();

            document.head.appendChild(script);
        },

        handleAdMount(){
            if(typeof adsbygoogle === 'undefined'){
                return;
            }

            this.pushAds();
        },

        pushAds() {
            (adsbygoogle = window.adsbygoogle || []).push({});

            setTimeout(() => {
                if (this.$el.dataset.adStatus !== 'filled') {
                    delete this.$el.dataset.adSlot;
                    delete this.$el.dataset.adLayoutKey;

                    this.handleResize();
                }
            }, 1000)
        },

        handleResize(){
            this.$el.innerHTML= '';

            if(typeof this.$el.dataset.adsbygoogleStatus !== 'undefined'){
                delete this.$el.dataset.adsbygoogleStatus;
            }

            typeof adsbygoogle !== 'undefined' && adsbygoogle.push({});
        },

        resizeHandler: {
            ['@resize.window.debounce.1500ms']() {
                this.handleResize();
            },
            ['x-intersect.once']() {
                if(!useIntersect) return;

                setTimeout(
                    () => typeof this.$el.dataset.adsbygoogleStatus === 'undefined'
                            && typeof this.$el.dataset.adStatus === 'undefined'
                                && this.pushAds(),
                    1000
                );
            }
        }
    };
}

export default GoogleAds;
